import * as React from "react";
import { cn } from "@/shared/lib/utils";

export interface CardContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * Card elevation and shadow styling:
   * - `standard`: Elevation matching Flutter `AdminCardContainer` (`shadow-card`, rounded-[22px])
   * - `soft`: Soft elevation matching Flutter `_LoginCard` (`shadow-card-soft`, rounded-[20px])
   * - `flat`: Flat card with subtle border
   */
  variant?: "standard" | "soft" | "flat";
}

/**
 * Standard rounded card container matching the Flutter KayerSoft design specs (`AdminCardContainer` / `_LoginCard`).
 * Implements standard 20px-22px corner radius and calibrated drop shadows.
 */
export function CardContainer({
  variant = "standard",
  className,
  children,
  ...props
}: CardContainerProps) {
  return (
    <div
      className={cn(
        "border border-slate-100 bg-white transition-shadow",
        variant === "standard" && "rounded-card shadow-card p-4 sm:p-5",
        variant === "soft" && "rounded-card-soft shadow-card-soft p-5 sm:p-6",
        variant === "flat" && "rounded-card border-border p-4 shadow-none",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
